import { useAppLifecycleStore } from '@/store/app-lifecycle.ts';
import { useUserStore } from '@/store/user.ts';
import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteNames, routes } from './routes.ts';

let isFirstLoad = false; // using native variable here instead of ref in lifecycle store to avoid overhead

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes
});

router.beforeResolve(async (to, from, next) => {
    const userStore = useUserStore();
    const { initialize } = useAppLifecycleStore();

    if (!isFirstLoad) {
        isFirstLoad = true;
        await initialize();
    }

    if (to.name !== RouteNames.LOGIN && to.meta.requiresLoggedIn && !userStore.isAuthenticated) {
        next({ name: RouteNames.LOGIN });
    } else {
        next();
    }
});

export default router;